import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid p-formgrid" }
const _hoisted_2 = { class: "p-field-checkbox p-col-12" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
      start: _withCtx(() => [
        (!_ctx.expandFilterCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandFilterCard = true))
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-chevron-up",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandFilterCard = false))
            })),
        _createVNode("span", null, _toDisplayString(_ctx.$t('common.filters')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.expandFilterCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-check",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.applyFilters
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.expandFilterCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-eraser",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.resetFilters
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Checkbox, {
              class: "p-mr-2",
              modelValue: _ctx.showMissingElements,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMissingElements = $event)),
              binary: true,
              disabled: !_ctx.selectedHierarchy
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.hierarchyManagement.showMissingElements')), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_Calendar, {
                class: "kn-material-input",
                modelValue: _ctx.afterDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.afterDate = $event)),
                manualInput: true,
                showIcon: true,
                disabled: !_ctx.selectedHierarchy
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.hierarchyManagement.afterDate')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.expandFilterCard]
    ])
  ], 64))
}